export default "__VITE_ASSET__C3av4KSe__"